import React from 'react';
import { ContentHeader } from '../../../components/layout/ContentHeader';
import { CType } from '../../../provider/Typo3Provider/types';

const HeaderContainer = (props: CType) => <ContentHeader {...props} />;

export default HeaderContainer;
